export const BULK_UPLOAD_BATCH = "BULK_UPLOAD_BATCH";
export const UPLOAD_BATCH_ID = "UPLOAD_BATCH_ID";
export const GET_BULK_UPLOAD_DETAILS = "GET_BULK_UPLOAD_DETAILS";
export const SET_BULK_UPLOAD_DETAILS = "SET_BULK_UPLOAD_DETAILS";
export const GET_ITEMS_EXCEL_BY_STORE_ID = "GET_ITEMS_EXCEL_BY_STORE_ID";
export const DOWNLOAD_BULK_ITEMS_EXCEL_BY_STORE_ID = "DOWNLOAD_BULK_ITEMS_EXCEL_BY_STORE_ID";
export const GET_STORE_ITEMS_IN_EXCEL = "GET_STORE_ITEMS_IN_EXCEL";
export const UPLOAD_GST_BATCH_ID = "UPLOAD_GST_BATCH_ID";
export const SET_GST_BULK_UPLOAD_DETAILS = "SET_GST_BULK_UPLOAD_DETAILS";
